import { scriptsUninstallAll } from "../uninstallScript/uninstallScript";

async function uninstallAllFromMaximo(checkVersions, confirm = false) {
  return await scriptsUninstallAll(checkVersions, confirm);
}

export default uninstallAllFromMaximo;
